import {Injectable} from '@angular/core';
import Swal, {SweetAlertType} from 'sweetalert2';
import { NumericTextBox } from '@syncfusion/ej2-inputs';

declare var $;

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  onlyNumber(e) {
    if ((e.charCode < 48 || e.charCode > 57))
      return false;
    return true;
  }

  public getCurrentdate() {
    let dtToday = new Date();



    let month: any = dtToday.getMonth() + 1;
    let day: any = dtToday.getDate();
    let year: any = dtToday.getFullYear();




    if (month < 10)
      month = '0' + month.toString();
    if (day < 10)
      day = '0' + day.toString();



    let minDate: any = year + '-' + month + '-' + day;



    return minDate;
  }

  public static clone(jsonObject: object) {
    return JSON.parse(JSON.stringify(jsonObject));
  }

  public isNumeric(value): boolean {
    return $.isNumeric(value);
  }

  public isNumericNull(value): number {
    return (value == null || value == undefined) ? 0 : value;
  }
  public isDateNull(value): Date {
    return (value == null || value == undefined) ? new Date('1/1/1999') : value;
  }
  public isStringNull(value): string {
     return (value == null || value == undefined) ? '' : value.trim();
  }
  public ArrayToCommaSeperator(value): string {
    let stRtn = ''; 
    if (value != null && value != undefined) {
      //for (var i = 0; i < value.length; i++) {
      //  stRtn += value[i];
      //}
      //stRtn = stRtn.replace(/,\s*$/, "");
      stRtn = value.toString();
    }
    return stRtn;
  }
  public CommaSeperatorToArray(value: string): number[] {
    let inpUno: any = [];
    if (value != null && value != undefined && value != '' && value.indexOf(",") > 0) {
      let tempVar: any = value.split(',');
      for (var i = 0; i < tempVar.length; i++) {
        if (tempVar[i] != null && tempVar[i] != undefined && tempVar[i] != '') {
          // Add additional code here, such as:
          inpUno.push(tempVar[i].toString())
        }        
      }
    }
    else if (value != null && value != '') {
      //let inpUno: number[] = [];
      inpUno.push(value.toString())
      return inpUno;
    }
    else if (value == null || value == undefined || value=='') {
      return [];
    }
    
    
    return inpUno;
  }
  public CommaSeperatorToArrayParseInt(value: string): number[] {
    let inpUno: number[] = [];
    if (value != null && value != undefined && value != '' && value.indexOf(",") > 0) {
      let tempVar: any = value.split(',');
      for (var i = 0; i < tempVar.length; i++) {
        if (tempVar[i] != null && tempVar[i] != undefined && tempVar[i] != '') {
          // Add additional code here, such as:
          inpUno.push(parseInt(tempVar[i]))
        }
      }
    }
    else if (value != null && value != '') {
      //let inpUno: number[] = [];
      inpUno.push(parseInt(value))
      return inpUno;
    }
    else if (value == null || value == undefined || value == '') {
      return [];
    }


    return inpUno;
  }
  public allowNumberPaste(event: ClipboardEvent): boolean {
    let clipboardData, pastedData;
    // Get pasted data via clipboard API
    clipboardData = event.clipboardData || window['clipboardData'];
    pastedData = clipboardData.getData('Text');
    return this.isNumeric(pastedData);
  }

  showAlert(message: string, type: SweetAlertType= 'error') {
    Swal.fire({
      type: type,
      title: message
    });
  }

  InboxFilter_store(objfilterBy: number, objsla: number, objyear: number, objquater: number, objdivision: number, objfrequency: number) {
    if (window.localStorage) {
      // Create item:
      let inboxstVal = 'inbox_filter_musherat_storage';
      localStorage.removeItem(inboxstVal);
      let myObj = { filterBy: objfilterBy, sla: objsla, year: objyear, quater: objquater, division: objdivision, frequency: objfrequency };
      localStorage.setItem(inboxstVal, JSON.stringify(myObj));
    }
  }
  InboxFilter_get() {
    if (window.localStorage) {
      // Get item:
      let inboxstVal = 'inbox_filter_musherat_storage';
      return JSON.parse(localStorage.getItem(inboxstVal));
    }
    return null;
  }

  public getnodataImage() {
    
    var d = new Date();
    let n = d.getMilliseconds();
    let rndnumber = (n >= 0 && n <= 55) ? 1 : (n >= 56 && n <= 93) ? 2 : (n >= 94 && n <= 150) ? 2 : (n >= 151 && n <= 200) ? 3 :
      (n >= 201 && n <= 250) ? 4 : (n >= 251 && n <= 349) ? 5 : (n >= 350 && n <= 445) ? 6 : (n >= 446 && n <= 525) ? 7 : (n >= 526 && n <= 610) ? 8 :
        (n >= 611 && n <= 720) ? 9 : (n >= 721 && n <= 790) ? 10 : (n >= 791 && n <= 850) ? 11 : (n >= 851 && n <= 950) ? 12 : 1;
    switch (rndnumber) {
      case 1: 
        return "assets/img/no-data-image/np-data11.jpg";
      case 2:
        return "assets/img/no-data-image/np-data2.jpg";
      case 3:
        return "assets/img/no-data-image/np-data10.jpg";
      case 4:
        return "assets/img/no-data-image/np-data4.jpg";
      case 5:
        return "assets/img/no-data-image/np-data5.jpg";
      case 6:
        return "assets/img/no-data-image/np-data6.jpg";
      case 7:
        return "assets/img/no-data-image/np-data7.jpg";
      case 8:
        return "assets/img/no-data-image/np-data8.jpg";
      case 9:
        return "assets/img/no-data-image/np-data9.jpg";
      case 10:
        return "assets/img/no-data-image/np-data10.jpg";
      case 11:
        return "assets/img/no-data-image/np-data11.jpg";
      case 12:
        return "assets/img/no-data-image/np-data12.jpg";

      default:
        return "assets/img/no-data-image/np-data1.jpg";

    }

  }
  getFileIconClass(fileTitle: string) {

    if (fileTitle == '' || fileTitle == null)
      return "fa fa-file";

    var rtnClass = "fa fa-file";
    var strTitle = (fileTitle.indexOf('.') > 0) ? fileTitle.split('.')[1].toLowerCase() : 'unknown';

    switch (strTitle) {
      case 'txt':
        rtnClass = "fa fa-file-o";
        break;
      case 'doc':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'docx':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'xls':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'xlsx':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'pdf':
        rtnClass = "fa fa-file-pdf-o";
        break;
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
        rtnClass = "fa fa-file-picture-o";
        break;
      case 'mp3':
        rtnClass = "fa fa-file-audio-o";
        break;
      case 'mp4':
      case 'mpeg':
      case 'mpg':
      case 'avi':
        rtnClass = "fa fa-file-video-o";
        break;
      default:
        rtnClass = "fa fa-file";
        break;
    }

    return rtnClass;

  }
}
